'use strict';

import config from '../js/config';
import {runRequest} from '../utilities/makeRequest';
import userService from '../services/CartUserService';
import { EnableHybrisIntegration as EnableHybrisIntegrationFF } from '../utilities/featureFlags';

/**
 * Only logged in, non-MyArrow, non-blocked users are eligible for perks, they need to be part of either QualifiedPerks or UnqualifiedPerks
 *
 * @returns {Promise.<boolean>}
 */
export function getPerksEligibility() {
    if (!userService.isUserLoggedIn()) {
    return Promise.resolve(false);
  }
  if (EnableHybrisIntegrationFF.isEnabled()){
    return userService.getUserInfo().then(userInfo => (((_.contains(userInfo.groups,'QualifiedPerks') || (_.contains(userInfo.groups,'UnqualifiedPerks'))) && userInfo.creditLimit === 0 && !userInfo.blocked))); 
  } 
  return userService.getUserInfo().then(userInfo => (userInfo.terms === false && userInfo.blocked === false));
}

/**
 * Load the users perk status from the cart api
 *
 * @returns {Promise.<{current: number, goal: number, percent: number, qualified: boolean}>}
 */
export function getPerksStatus() {
  return runRequest({
    url: config.urls.cart.getPromoDetails,
    dataType: 'json',
    handleErrorLocally: true,
    data: {
      format: 'json',
      campaignId: 'perks'
    },
    xhrFields: {
      withCredentials: true
    }
  })
    .then(request => {
      if (!request.response.CustomerStatistics || !request.response.CustomerStatistics.length ||
        !request.response.CustomerStatistics[0].PERKS || !request.response.CustomerStatistics[0].PERKS.length) {
        throw new Error('Perk data not found in response');
      }

      let perkData = request.response.CustomerStatistics[0].PERKS[0];

      perkData.currentAmount = Math.min(perkData.currentAmount, perkData.threshold);

      return {
        current: perkData.currentAmount,
        goal: perkData.threshold,
        percent: (perkData.currentAmount / perkData.threshold) * 100,
        qualified: perkData.dateQualified !== null
      };
    });
}

/**
 * Load the users perk status from Hybris b2busers call, groups are QualifiedPerks or UnqualifiedPerks
 *
 * @returns {Promise.<{qualified: boolean}>}
 *
 */
export function getHybrisPerksLevel() {
     return userService.getUserInfo()
      .then((userData) => {
        let isQualified = false;
        let grouplength = userData.groups.length;  
      if(grouplength > 0){     
        if( _.contains(userData.groups,'QualifiedPerks')){
        isQualified = true;
      }
      if(_.contains(userData.groups,'UnqualifiedPerks')){
        isQualified = false;
      }
      }    
      return {
        qualified:isQualified
       }
    });    
  }




// WEBPACK FOOTER //
// ./assets/services/PerksService.js